module.exports = __webpack_public_path__ + "static/media/altitude.b069bb72.png";